import moment from "moment";

const formatTime = (date) => {
  return date ? moment(date).format('HH:mm') : null;
};

export default formatTime;